/* Bloquea el selector de cantidad si el botón de compra está deshabilitado (agotado). */
(function () {
  function sync(root) {
    const qty = root.querySelector('.product-form__quantity');
    if (!qty) return;

    const submit = root.querySelector('.product-form__submit');
    const soldOut = Boolean(submit && submit.hasAttribute('disabled'));

    qty.classList.toggle('uc-qty-disabled', soldOut);
    qty.querySelectorAll('.quantity__input, .quantity__button').forEach(function (el) {
      el.toggleAttribute('disabled', soldOut);
    });
  }

  function syncAll() {
    document.querySelectorAll('product-info').forEach(sync);
  }

  document.addEventListener('DOMContentLoaded', syncAll);
  document.addEventListener('product-info:loaded', function (event) {
    if (event.target && event.target.matches && event.target.matches('product-info')) {
      sync(event.target);
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      requestAnimationFrame(syncAll);
    });
  }
})();
